import ConfigDB from "../../config/ThemeConfig";
import { ApexOptions } from "apexcharts";
import { LatLngExpression } from "leaflet";

const { primary_color, secondary_color } = ConfigDB.data.color;




export const pieChartData = [
  ["Category", "Value"],
  ["Trial - Active", 30],
  ["Trial - Inactive", 20],
  ["Live - Active", 40],
  ["Live - Inactive", 10],
];

export const pieChartOptions = {
  title: "",
  is3D: true,
  pieHole: 0.4,
  colors: [primary_color, "#48A3D7", secondary_color, "#FEB019"],  
  legend: {
    position: "bottom",
    alignment: "center",
    textStyle: {
      fontSize: 12,
      whiteSpace: "nowrap",
      bold: true, 
    },
    maxLines: 2,
  },
  chartArea: { width: "100%", height: "70%" },
  pieSliceText: "none",
  sliceVisibilityThreshold: 0,  
  slices: {
    1: { offset: 0.1, textStyle: { fontSize: 14, bold: true } },  
    3: { offset: 0.15, textStyle: { fontSize: 14, bold: true } },  
  },
  tooltip: { isHtml: true, trigger: 'focus' },
  
};

export const enhancedOptions = {
  ...pieChartOptions,
  chartArea: {
    left: 10,
    top: 10,
    width: "90%",
    height: "90%",
  },
  legend: {
    position: "right",
    alignment: "center",
    textStyle: {
      fontSize: 12,
      bold: true,  
    },
  },
  pieSliceText: "percentage",
  pieSliceTextStyle: {
    fontSize: 11,
    bold: true, 
    color: "#FFFFFF",
  },
  width: 500,
  height: 200,
  colors: ["#6BC6AF", secondary_color, "#6BC6AF", secondary_color],  
  slices: {
    0: { textStyle: { fontSize: 12, bold: true, color: "#FFFFFF" } },  
    1: { offset: 0.1, textStyle: { fontSize: 12, bold: true, color: "#FFFFFF" } },  
    2: { textStyle: { fontSize: 12, bold: true, color: "#FFFFFF" } },  
    3: { offset: 0.15, textStyle: { fontSize: 12, bold: true, color: "#FFFFFF" } },  
  },
};

export const lineChartData = [
  ["Month", "Active Users", "New Organizations", "CRM Sales"],
  [1, 1500, 25, 120],
  [2, 1800, 30, 150],
  [3, 2200, 35, 180],
  [4, 2500, 40, 200],
  [5, 2800, 45, 220],
  [6, 3100, 50, 240],
  [7, 3400, 55, 260],
  [8, 3700, 60, 280],
];

export const barOneChartData = [
  [
    "Role",
    "Count",
    {
      role: "style",
    },
    {
      sourceColumn: 0,
      role: "annotation",
      type: "string",
      calc: "stringify",
    },
  ],
  ["Super Admin", 5, "#6BC6AF", 5],
  ["Organization Admin", 20, secondary_color, 20],
  ["Manager", 50, "#6BC6AF", 50],
  ["User", 125, secondary_color, 125],
];

export const barOneChartDataOption = {
  height: 200,
  bar: {
    groupWidth: "95%",
  },
  legend: {
    position: "none",
  },
  hAxis: {
    title: "Number of Users",
    minValue: 0,
    textStyle: { fontSize: 10 },
  },
  vAxis: {
    title: "Roles",
    textStyle: { fontSize: 12 },
  },
  chartArea: { width: "80%", height: "70%" },
  annotations: {
    textStyle: {
      fontSize: 12,
      bold: true,
      color: "#333",
    },
  },
};

export const annotationChartData: ApexOptions = {
  annotations: {
    yaxis: [
      {
        y: 400,
        borderColor: "#00E396",
        label: {
          borderColor: "#00E396",
          style: {
            color: "#fff",
            background: "#00E396",
          },
          text: "Growth Milestone",
        },
      },
      {
        y: 450,
        y2: 500,
        borderColor: "#000",
        fillColor: "#FEB019",
        opacity: 0.2,
        label: {
          borderColor: "#333",
          style: {
            fontSize: "10px",
            color: "#333",
            background: "#FEB019",
          },
          text: "Current Range",
        },
      },
    ],
    xaxis: [
      {
        x: new Date("2025-07-01").getTime(),
        strokeDashArray: 0,
        borderColor: "#775DD0",
        label: {
          borderColor: "#775DD0",
          style: {
            color: "#fff",
            background: "#775DD0",
          },
          text: "July Onboarding",
        },
      },
      {
        x: new Date("2025-07-23").getTime(),
        x2: new Date("2025-07-31").getTime(),
        fillColor: "#B3F7CA",
        opacity: 0.4,
        label: {
          borderColor: "#B3F7CA",
          style: {
            fontSize: "10px",
            color: "#fff",
            background: "#00E396",
          },
          offsetY: -10,
          text: "Latest Data",
        },
      },
    ],
    points: [
      {
        x: new Date("2025-07-23").getTime(),
        y: 450,
        marker: {
          size: 8,
          fillColor: "#fff",
          strokeColor: "#FF4560",
          cssClass: "apexcharts-custom-class",
        },
        label: {
          borderColor: "#FF4560",
          offsetY: 0,
          style: {
            color: "#fff",
            background: "#FF4560",
          },
          text: "Today: 450 Users",
        },
      },
    ],
  },
  chart: {
    height: 350,
    type: "line",
    id: "areachart-2",
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "straight",
  },
  grid: {
    padding: {
      right: 30,
      left: 20,
    },
  },
  series: [
    {
      data: [],
    },
  ],
  title: {
    text: "New Users Over Time (2025)",
    align: "left" as const,
  },
  labels: [],
  xaxis: {
    type: "datetime",
  },
  colors: ["#51bb25"],
  legend: {
    show: false,
  },
};

export const organizationStatData = [
  {
    icon: "work",
    amount: "45",
    title: "Total Organizations",
    arrowIcon: "arrow-chart-up",
    percentage: "+34%",
    chartClass: "earning-chart",
    id: "earning-chart",
    chart: "",
  },
  {
    icon: "send",
    amount: "12,500",
    title: "Active Users",
    arrowIcon: "arrow-chart-up",
    percentage: "+8%",
    classExtra: "up-sales",
    chartClass: "sales-chart",
    id: "sales-chart",
    chart: "",
  },
  {
    icon: "graph",
    amount: "$97,000,000",
    title: "Total Payments",
    arrowIcon: "arrow-chart",
    percentage: "-5%",
    classExtra: "total-product",
    chart: "",
  },
];

export const baseOrganizations = [
  {
    id: "ORG001",
    name: "TechCorp Inc.",
    position: [37.7749, -122.4194] as LatLngExpression,
    country: "USA",
  },
  {
    id: "ORG002",
    name: "HealthSync Ltd.",
    position: [51.5074, -0.1278] as LatLngExpression,
    country: "UK",
  },
  {
    id: "ORG003",
    name: "EduFuture Org.",
    position: [35.6762, 139.6503] as LatLngExpression,
    country: "Japan",
  },
  {
    id: "ORG004",
    name: "GreenEnergy Co.",
    position: [-33.8688, 151.2093] as LatLngExpression,
    country: "Australia",
  },
  {
    id: "ORG005",
    name: "FinTech Africa",
    position: [-1.2921, 36.8219] as LatLngExpression,
    country: "Kenya",
  },
  {
    id: "ORG006",
    name: "BioMed Europe",
    position: [48.8566, 2.3522] as LatLngExpression,
    country: "France",
  },
  {
    id: "ORG007",
    name: "AgroSouth",
    position: [-34.6037, -58.3816] as LatLngExpression,
    country: "Argentina",
  },
  {
    id: "ORG008",
    name: "Polar Research",
    position: [-75.250973, -0.071389] as LatLngExpression,
    country: "Antarctica",
  },
  {
    id: "ORG009",
    name: "Silicon Valley Startups",
    position: [37.3382, -121.8863] as LatLngExpression,
    country: "USA",
  },
  {
    id: "ORG010",
    name: "NYC Innovators",
    position: [40.7128, -74.006] as LatLngExpression,
    country: "USA",
  },
  {
    id: "ORG011",
    name: "Berlin Tech",
    position: [52.52, 13.405] as LatLngExpression,
    country: "Germany",
  },
  {
    id: "ORG012",
    name: "Moscow Analytics",
    position: [55.7558, 37.6173] as LatLngExpression,
    country: "Russia",
  },
  {
    id: "ORG013",
    name: "Cape Town Creatives",
    position: [-33.9249, 18.4241] as LatLngExpression,
    country: "South Africa",
  },
  {
    id: "ORG014",
    name: "Dubai Enterprises",
    position: [25.2048, 55.2708] as LatLngExpression,
    country: "UAE",
  },
  {
    id: "ORG015",
    name: "Beijing Innovations",
    position: [39.9042, 116.4074] as LatLngExpression,
    country: "China",
  },
  {
    id: "ORG016",
    name: "Delhi Solutions",
    position: [28.6139, 77.209] as LatLngExpression,
    country: "India",
  },
  {
    id: "ORG017",
    name: "Sao Paulo Digital",
    position: [-23.5505, -46.6333] as LatLngExpression,
    country: "Brazil",
  },
  {
    id: "ORG018",
    name: "Toronto Tech",
    position: [43.6532, -79.3832] as LatLngExpression,
    country: "Canada",
  },
  {
    id: "ORG019",
    name: "Singapore Startups",
    position: [1.3521, 103.8198] as LatLngExpression,
    country: "Singapore",
  },
  {
    id: "ORG020",
    name: "Seoul Innovators",
    position: [37.5665, 126.978] as LatLngExpression,
    country: "South Korea",
  },
];

export const circleChartData: ApexOptions = {
  plotOptions: {
    radialBar: {
      dataLabels: {
        name: {
          fontSize: "22px",
        },
        value: {
          fontSize: "16px",
          formatter: function (val: number): string {
            return String(val);
          },
        },
        total: {
          show: true,
          label: "Total",
          formatter: function () {
            return "300";
          },
        },
      },
    },
  },
  series: [50, 75, 90, 85],
  labels: ["Basic", "Premium", "Freemium", "Enterprise"],
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          height: 300,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                offsetY: -1,
              },
              value: {
                offsetY: 4,
              },
            },
          },
        },
      },
    },
  ],
  colors: [secondary_color, "#6BC6AF", secondary_color, "#6BC6AF"],
};

export const areaSpalineChart: ApexOptions = {
  chart: {
    height: 310,
    type: "area",
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
  },
  series: [
    {
      name: "Organization count",
      data: [10, 15, 12, 18, 20, 25, 22],
    },
    {
      name: "Users",
      data: [30, 40, 35, 45, 50, 55, 60],
    },
    {
      name: "Mobile App Users",
      data: [20, 25, 22, 30, 35, 40, 45],
    },
  ],
  xaxis: {
    type: "datetime",
    categories: [
      "2025-07-01T00:00:00",
      "2025-07-02T00:00:00",
      "2025-07-03T00:00:00",
      "2025-07-04T00:00:00",
      "2025-07-05T00:00:00",
      "2025-07-06T00:00:00",
      "2025-07-07T00:00:00",
    ],
  },
  tooltip: {
    x: {
      format: "dd/MM/yy",
    },
  },
  colors: [ "#5C61F2",secondary_color ,"#6BC6AF"],
};